import styled from 'styled-components';
const calcColumnPercentage = num => `${(num / 12) * 100}%`;
export const Col = styled.div `
  background-color: #fff;
  display: inline-flex;

  flex-direction: column;

  ${({ gutters }) => {
    if (gutters) {
        return `
        padding-left: ${gutters}px;
        padding-right: ${gutters}px;
      `;
    }
}}

  width: ${({ sm }) => (sm ? calcColumnPercentage(sm) : '100%')};

  ${({ md }) => {
    if (md) {
        return `
      @media (min-width: 768px) {
        width: ${calcColumnPercentage(md)};
      }
      `;
    }
}}

  ${({ lg }) => {
    if (lg) {
        return `
      @media (min-width: 1024px) {
        width: ${calcColumnPercentage(lg)};
      }
      `;
    }
}}

  ${({ xl }) => {
    if (xl) {
        return `
      @media (min-width: 1280px) {
        width: ${calcColumnPercentage(xl)}
      }
      `;
    }
}}

  ${props => {
    if (props['2xl']) {
        return `
      @media (min-width: 1536px) {
        width: ${calcColumnPercentage(props['2xl'])}
      }
      `;
    }
}}
`;
